import React, { useRef } from 'react';
import { Card, ARTICLE_CARD, ELEVATED, VERTICAL_LAYOUT, Tooltip } from '@mds/mds-reactjs-library';
import PreviewDownloadButton from './PreviewDownloadButton';

const FilesLists = ({ folder, searching, preview, download }) => {
  const spanRefs = useRef({});

  const checkOverflow = (fileId) => {
    const spanRef = spanRefs.current[fileId];
    if (spanRef) {
      const isOverflowing = spanRef.offsetHeight > 40;
      return isOverflowing;
    }
  };

  return (
    folder.isFolder &&
    <div className="flex">
      {folder.children && folder.children.length > 0 && folder.children
        .filter(
          item =>
            !item.isFolder && (item.title.toLowerCase().includes(searching) ||
              item.description.toLowerCase().includes(searching))
        )
        .map(file => (
          <div className="card-container" tabIndex="0"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              preview(e, file);
            }
          }} onClick={e => preview(e, file)} key={file.fileId}>
            <Card
              title={file.title}
              imageProps={{ src: `data:${file.thumbnailMimetype};base64,${file.thumbnail}`, alt: file.title }}
              layout={VERTICAL_LAYOUT}
              variation={ELEVATED}
              type={ARTICLE_CARD}
              matchHeight={true}
              social={<PreviewDownloadButton file={file} download={download} preview={preview} />}
            >
              <Tooltip placement='right' content={file.description} onShow={() => checkOverflow(file.fileId)}>
                <span ref={(el) => (spanRefs.current[file.fileId] = el)} className="last-child">{file.description}</span>
              </Tooltip>
            </Card>
          </div>
        ))}
    </div>
  );
}
export default FilesLists;